<template>
  <q-page
    class="static q-mb-xl"
    dir="ltr"
  >
    <section class="container q-px-md no-rtl">
      <div class="row justify-center">
        <div class="col-md-8">
          <h1 class="text-black">{{ $t('pages.terms_of_use.header') }}</h1>
          <div
            v-for="subitem in $t('pages.terms_of_use.subitems')"
            :key="subitem.header"
          >
            <h3 class="text-black">
              {{ subitem.header }}
            </h3>
            <p
              v-for="item in subitem.items"
              :key="item"
              class="terms-item q-my-md text-justify"
              v-html="item.replace('%{privacy_policy_url}', linkToPrivacyPolicy.href)"
            />
          </div>
          <company-details />
        </div>
      </div>
    </section>
  </q-page>
</template>

<script>
import CompanyDetails from 'components/CompanyDetails';

export default {
  name: 'TermsOfUse',
  components: {
    CompanyDetails,
  },
  data() {
    return {
      linkToPrivacyPolicy: this.$router.resolve({
        name: 'privacy_policy',
        query: this.$route.query,
      }, this.$route),
    };
  },
};
</script>
